export default __webpack_public_path__ + "static/media/asking_contact.9afcf2b1.png";